<template>
  <div class="bet-history-page">
    <div class="accpage bet-history" v-if="!isLoggedIn && brandTemplate === 'generic_2'">
      <div class="hs_tabs">
        <span @click="setTabNotLoggedInUser('HistoryActive', true)" :class="{ 'tab':true, 'active': historystate==='active' }">
          <a class="a-link- history-tab"><span>{{ $t('BetSlipPage.tab.History.active') }}</span></a>
        </span>
        <span @click="setTabNotLoggedInUser('HistorySettled')" :class="{ 'tab':true, 'active': historystate==='settled' }">
          <a class="a-link- history-tab"><span>{{ $t('BetSlipPage.tab.History.settled') }}</span></a>
        </span>
      </div>
      <div class="not_logged_in">
        <div class="history_notloggedin_img"></div>
        <div class="history_notloggedin">{{ $t('Statement.LoginToSeeBetHistory') }}</div>
        <v-btn @click="openDialogLogin()" class="history_login primary primary-btn-blue">{{ $t('MyAccount.LogIn') }}</v-btn>
      </div>
    </div>
    <div class="accpage bet-history" v-if="isLoggedIn">
      <template v-if="!mobileBigAndBelow || !accountSummaryFlow">
        <h1 v-if="brandKey !== 'sb'">{{ $t('Account.BetHistory') }}</h1>
        <h1 v-if="brandKey === 'sb'">{{ $t('Account.BetHistory.' + historystate) }}</h1>
      </template>
      <template v-if="mobileBigAndBelow && accountSummaryFlow && brandTemplate!== 'generic_2'">
        <div v-if="brandKey !== 'sb'" class="account-heading"><icon name="icon-settled-bets"></icon>
          {{ $t('Account.BetHistory') }}
        </div>
        <div v-if="brandKey === 'sb'" class="account-heading"><icon :name="'icon-' + historystate + '-bets'"></icon>
          {{ $t('Account.BetHistory.' + historystate) }}
        </div>
      </template>
      <div class="selectHolder" v-if="brandTemplate === 'generic_2' && historyQueryTypesItems && historyQueryTypesItems.length > 1">
        <v-select v-model="historyQueryType" @click.stop="doNothing()" class="asMenu"
                  @change="setTabHistoryAuto()"
                  :items="historyQueryTypesItems"
                  :label="''"></v-select>
      </div>
      <div class="hs_tabs" :class="{'hidden' : brandKey === 'sb'}">
        <span class="selectHolder" v-if="brandTemplate !== 'generic_2' && historyQueryTypesItems && historyQueryTypesItems.length > 1">
          <v-select v-model="historyQueryType" @click.stop="doNothing()" class="asMenu"
                    @change="setTabHistoryAuto()"
                    :items="historyQueryTypesItems"
                    :label="''"></v-select>
        </span>
        <span @click="setTab('HistoryActive', true)" :class="{ 'tab':true, 'active': historystate==='active' }">
          <a class="a-link- history-tab"><span>{{ $t('BetSlipPage.tab.History.active') }}</span></a>
        </span>
        <span @click="setTab('HistorySettled')" :class="{ 'tab':true, 'active': historystate==='settled' }">
          <a class="a-link- history-tab"><span>{{ $t('BetSlipPage.tab.History.settled') }}</span></a>
        </span>
        <span v-if="historystate==='all'" @click="setTab('HistoryAll')" :class="{ 'tab':true, 'active': historystate==='all' }">
          <a class="a-link- history-tab"><span>{{ $t('BetSlipPage.tab.History.all') }}</span></a>
        </span>
      </div>
      <statement v-if="historystate==='active'" :selectedState="'Open'"></statement>
      <statement v-if="historystate==='settled'" :selectedState="'NonOpen'"></statement>
      <statement v-if="historystate==='all' || historystate===''" :selectedState="'All'"></statement>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import store from '@/store'
  import Screen from '@/components/mixins/Screen'
  import Statement from '@/components/account/Statement'
  import Branding from '@/components/mixins/Branding'
  import Icon from '@/components/common/Icon'
  import Gtm from '@/components/mixins/Gtm'
  import mobileBridge from '@/library/mobileBridge'

  export default {
    name: 'BetHistory',

    mixins: [
      Screen,
      Branding,
      Gtm
    ],

    components: {
      Statement,
      Icon
    },

    data: () => ({
      historyQueryType: ''
    }),

    computed: {
      historystate () {
        return this.$route.params.state || ''
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      useBuyBack () {
        return store.getters['statementState/useBB']
      },
      historyQueryTypes () {
        return store.getters['statementState/historyQueryTypes']
      },
      activeQueryType () {
        return store.getters['statementState/activeQueryType']
      },
      historyQueryTypesItems () {
        if (!this.historyQueryTypes.length) {
          return
        }
        var self = this
        //
        var items = [
        ]
        for (var i = 0; i < self.historyQueryTypes.length; i++) {
          var item = {
            text: self.$t('Account.BetHistory.QueryType.' + self.historyQueryTypes[i]),
            value: self.historyQueryTypes[i]
          }
          items.push(item)
        }

        self.historyQueryType = self.activeQueryType || self.historyQueryTypes[0]
        return items
      },
      accountSummaryFlow () {
        return window.ctsautoconf.ACCOUNT_SUMMARY_FLOW || false
      },
      biometricsAvailability () {
        return store.getters['getBiometricsAvailability']
      },
      biometricsSettings () {
        return store.getters['getBiometricsSettings']
      },
      MobilelocalServer () {
        return window.ctsautoconf.MOBILE_LS || false
      },
      isFitForPLayEnabled () {
        return config.app.autoconf.ENABLE_FIT_FOR_PLAY
      }
    },
    methods: {
      setTab (tab, activateTab = false) {
        let initObj = {}
        let willTrigerRouterChange = false
        switch (tab) {
          case 'HistoryActive':
            initObj.fetchHistory = true
            initObj.queryType = this.historyQueryType
            initObj.queryStatus = 'Open'
            initObj.historyDateRange = { from: null, to: null }
            if (this.historystate !== 'active' && activateTab) {
              this.$router.push({ name: 'history-state', params: { state: 'active' } })
              willTrigerRouterChange = true
            }
            break
          case 'HistorySettled':
            initObj.fetchHistory = true
            initObj.queryType = this.historyQueryType
            initObj.queryStatus = 'NonOpen'
            initObj.historyDateRange = { from: new Date(), to: new Date() }
            initObj.historyDateRange.from.setDate(initObj.historyDateRange.from.getDate() - 7) // move 'from' 7 days in the past
            if (this.historystate !== 'settled') {
              this.$router.push({ name: 'history-state', params: { state: 'settled' } })
              willTrigerRouterChange = true
            }
            break
          case 'HistoryAll':
            initObj.fetchHistory = true
            initObj.queryStatus = 'All'
            initObj.historyDateRange = { from: new Date(), to: new Date() }
            initObj.historyDateRange.from.setDate(initObj.historyDateRange.from.getDate() - 7) // move 'from' 7 days in the past
            if (this.historystate !== 'all') {
              this.$router.push({ name: 'history-state', params: { state: 'all' } })
              willTrigerRouterChange = true
            }
            break
          default:
            if (this.historystate !== 'active') {
              this.$router.push({ name: 'history-state', params: { state: 'active' } })
              willTrigerRouterChange = true
            }
            break
        }
        if (!willTrigerRouterChange) {
          store.dispatch('statementState/initStatement', initObj)
        } else {
          // data load will be triggered from router change for historystate watch
        }
      },
      setTabNotLoggedInUser (tab, activateTab = false) {
        switch (tab) {
          case 'HistoryActive':
            if (this.historystate !== 'active' && activateTab) {
              this.$router.push({ name: 'history-state', params: { state: 'active' } })
            }
            break
          case 'HistorySettled':
            if (this.historystate !== 'settled') {
              this.$router.push({ name: 'history-state', params: { state: 'settled' } })
            }
            break
          case 'HistoryAll':
            if (this.historystate !== 'all') {
              this.$router.push({ name: 'history-state', params: { state: 'all' } })
            }
            break
          default:
            if (this.historystate !== 'active') {
              this.$router.push({ name: 'history-state', params: { state: 'active' } })
            }
            break
        }
      },
      setTabHistoryAuto () {
        if (this.historystate && this.isLoggedIn) {
          switch (this.historystate) {
            case 'active':
              this.setTab('HistoryActive')
              break
            case 'settled':
              this.setTab('HistorySettled')
              break
            case 'all':
              this.setTab('HistoryAll')
              break
            default:
              this.setTab('HistoryAll')
              break
          }
        }
      },
      openDialogLogin () {
        let faceIdState = (window.ctsautoconf.MOBILE_LS && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN) ? JSON.parse(localStorage.biometricsState) : false
        if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN) && !this.isFitForPLayEnabled) {
          store.dispatch('overlayState/activateLoginDialog')
          mobileBridge.bridgeSendRequest('readData')
          this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'top header')
          return false
        } else if ((this.biometricsAvailability && this.biometricsAvailability.biometrics === 'DATA') && faceIdState && (this.MobilelocalServer && window.ctsautoconf.APP_BIOMETRICS_AUTOMATIC_LOGIN) && this.isFitForPLayEnabled) {
          store.dispatch('overlayState/activateLoginDialog')
          this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'top header')
          return false
        }
        store.dispatch('overlayState/activateLoginDialog')
        this.sendGTMClickEvent('login', 'open login dialog', 'login-btn', 'top header')
      }
    },
    watch: {
      historystate () {
        this.setTabHistoryAuto()
      },
      isLoggedIn (newVal, oldVal) {
        if (newVal === true) {
          this.setTabHistoryAuto()
        }
      }
    },
    mounted () {
      this.setTabHistoryAuto()
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/css/config'
  @import '~@/css/mixins'
  .bet-history
    .hs_tabs
      display flex
      justify-content center
      align-items center
      padding-bottom 20px
    .tab 
      padding 5px 15px
      margin 0 5px
      height 34px !important
      min-height 34px
      border 1px solid #0b4da1 !important
      display flex
      align-items center
      cursor pointer
      a
        color #0b4da1!important
      &.active
        background #0b4da1!important
        a
          color #fff !important
>>>.fdr-wrap
  width 400px
  max-width 90%
  margin 0 auto

.selectHolder
  position relative
  width: 40%
  margin-right 5px
  @media mobile-big-and-below
    width 100%
    margin-left 10px
  >>>.v-select__slot
    border 0px
    height 34px
    padding 0
  >>>.v-select__selection
    @media mobile-big-and-below
      font-size: 14px
      margin: 0
  >>>.v-text-field__details
    display none
  >>>.v-input__slot
    margin 0
  >>>.v-text-field
    margin 0
    padding 0


</style>



// WEBPACK FOOTER //
// src/components/account/BetHistory.vue